"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultOptionalInclusions = void 0;
var DefaultOptionalInclusions = exports.DefaultOptionalInclusions = {
  'routineCare': ['Desexing', 'Microchipping', 'Heartworm Control / Prevention', 'Teeth Cleaning', 'Prescription Diets', 'Cremation or Burial', 'Dew Claw Removal'],
  'dental': ['Gingivitis', 'Abscesses and removal of teeth where medically necessary due to: Dental Disease arising from infection, Retained deciduous teeth, Cavities and Fractured teeth.']
};